import { Renderer2 } from '@angular/core';

export const setStyles = (renderer: Renderer2, element: unknown, styles: { [key: string]: string }) => {
  Object.keys(styles).forEach((key) => renderer.setStyle(element, key, styles[key]));
};

export const setAttributes = (renderer: Renderer2, element: unknown, attributes: { [key: string]: string }) => {
  Object.entries(attributes).forEach(([key, value]) => renderer.setAttribute(element, key, value));
};
